import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import AsyncSelect from '../../../shared/AsyncSelect/AsyncSelect';
import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/FormFields/TextField';
import SelectField from '../../../shared/FormFields/SelectField';
import RadioContainer from '../../../shared/FormFields/RadioContainer';
import CheckboxContainer from '../../../shared/FormFields/CheckboxContainer';
import fetch from 'isomorphic-fetch';
import {
  FaSpinner,
  FaLeaf,
  FaRecycle,
  FaGlobeEurope,
  FaGlobe,
  FaGlobeAmericas,
} from 'react-icons/fa';

// import { cities } from './cities';

import { primary_s10_l90 } from '../../../shared/lib/colors';
import { css } from '@emotion/core';

import {
  getCartTotalWithExpenses,
  existsFreeShipping,
  hasFreeShipping,
  getCartTotalDiscountedCoupon,
} from '../../../../redux/modules/cart';
import {
  getShippingCost,
  saveShipping,
  createOrder,
  getEnabledCities,
  geocodeAddress,
} from '../../../../redux/modules/checkout';
import { loadCities } from '../../../../redux/modules/cities';
import { loadPudos } from '../../../../redux/modules/pudo';
import { loadCountries } from '../../../../redux/modules/countries';
import { loadCart } from '../../../../redux/modules/cart';

import {
  codiceFiscaleValido,
  cognomeCoerente,
  nomeCoerente,
  getSesso,
} from '../../../shared/lib/codiceFiscale';

import { checkoutStep } from '../../../shared/lib/gaEnhancedEcommerce';

import Price from '../../../shared/Price/Price';

import { MdHelpOutline } from 'react-icons/md';
import './Spedizione.scss';
import api from '../../../../api';
import axios from 'axios';
import { ga4AddShippingInfo } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxAddShippingInfo } from '../../../shared/lib/farmakomMetrics';
import { setGuestCheckout } from '../../../../redux/modules/checkout';
import { gtmToGa4AddShippingInfo } from '../../../shared/lib/gtmEnhancedEcommerce';

class Spedizione extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pickupAtPharmacy: false,
      withRicetta: this.props.checkout.doneRicetta,
      fastShippingEnabled: false,
      packagingGreen: false,
      // shippingType: 'ESPRESSO',
      // shippingCost: this.props.checkout.shippingCost,
    };
  }

  ///////////////////////////////////
  // GOOGLE ANALYTICS STEP 3
  gaStep3(cart) {
    const productsGA = cart.map(p => ({
      id: p.code || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));
    // SEND EVENT AFTER 1 SEC
    setTimeout(() => {
      checkoutStep(productsGA, 3);
    }, 1000);
  }

  componentDidMount() {
    if (
      this.props.cart.find(product => !!product.prescription) &&
      !this.props.checkout.doneRicetta
    ) {
      this.props.router.push('/ricetta');
    }

    const { user } = this.props;

    if (!this.props.user.authenticated && !this.props.checkout.guestCheckout) {
      this.props.router.push('/carrello');
    }

    if (
      user.data.billing.taxCode === '' ||
      user.data.billing.address1 === '' ||
      user.data.billing.phone === '' ||
      user.data.billing.zipcode === '' ||
      user.data.billing.city === '' ||
      user.data.billing.province === '' ||
      user.data.shipping.phone === '' ||
      user.data.shipping.zipcode === '' ||
      user.data.shipping.city === '' ||
      user.data.shipping.address1 === ''
    ) {
      browserHistory.push('/profilo?modifica=true');
    }

    // SETTO NELLO STATE LA SPEDIZIONE DEFAULT
    // this.setState({
    // shippingType: 'ESPRESSO',
    // shippingCost: this.props.checkout.shippingCost,
    // });

    // CARICO I COMUNI
    // this.props.getEnabledCities();

    // CARICO LE NAZIONI
    this.props.loadCountries();

    // CALCOLA SPESE SPEDIZIONE CAP PREDEFINITO
    this.props.getShippingCost(
      localStorage.getItem('cartId'),
      this.props.user.data.shipping.zipcode,
      this.props.user.data.shipping.country
    );

    // GOOGLE ANALYTICS STEP 3
    if (this.props.advancedGa && this.props.cart) {
      this.gaStep3(this.props.cart);
    }

    // SE HANNO IL MODULO DEI PUDO SETTO NELLO STATE
    if (this.props.hasPudoBartolini) {
      this.setState({
        pudoAddress: this.props.user.data.shipping.address1,
        pudoCity: this.props.user.data.shipping.city,
        pudoZipcode: this.props.user.data.shipping.zipcode,
      });
    }

    // CONTROLLO SE LA SPEDIZIONE FAST BARTOLINI E' DISPONIBILE
    // this.checkBRTFastShipping();
  }

  componentDidUpdate(oldProps, oldState) {
    if (
      oldProps.checkout.loading !== this.props.checkout.loading &&
      !this.props.checkout.loading
    ) {
      // SETTO NELLO STATE LA SPEDIZIONE DEFAULT
      this.setState({
        shippingType: 'ESPRESSO',
        shippingCost: this.props.checkout.shippingCost,
      });
    }
    if (oldProps.cart.length !== this.props.cart.length) {
      if (
        this.props.cart.find(product => !!product.prescription) &&
        !this.props.checkout.doneRicetta
      ) {
        this.props.router.push('/ricetta');
      }
    }
    if (oldProps.country !== this.props.country) {
      this.props.change('shipping.city', '');
      // this.checkBRTFastShipping();
    }
    if (
      oldState.pudoAddress !== this.state.pudoAddress ||
      oldState.pudoZipcode !== this.state.pudoZipcode ||
      oldState.pudoCity !== this.state.pudoCity
    ) {
      this.getPudo();
    }
    if (
      oldProps.shippingDefault !== this.props.shippingDefault &&
      this.props.shippingDefault === 'pudo'
    ) {
      this.getPudo();
      // this.setState({
      //   pickupAtPharmacy: false,
      //   shippingType: 'ESPRESSO',
      //   shippingCost: this.props.checkout.shippingCost,
      // });
    }
    // if (oldState.selectedPudo !== this.state.selectedPudo) {
    //   const pudo = this.props.pudos.find(
    //     p => p.pudoId === this.state.selectedPudo
    //   );
    //   if (pudo) {
    //     this.checkBRTFastShipping(null, pudo.zipCode);
    //   }
    // }
  }

  // checkBRTFastShipping = (fromZipcode, toZipcode) => {
  //   let allowBRTFastShipping = false;
  //   let to = toZipcode;
  //   let from = fromZipcode;
  //   if (!to) {
  //     to = this.props.datiFarmacia.zipcode;
  //   }
  //   if (!from) {
  //     from = this.props.user.data.shipping.zipcode;
  //   }
  //   let cityFrom = cities.find(
  //     c => String(c.zipcode).substring(0, 3) == String(from).substring(0, 3)
  //   );
  //   let cityTo = cities.find(
  //     c => String(c.zipcode).substring(0, 3) == String(to).substring(0, 3)
  //   );
  //   if (cityFrom && cityTo) {
  //     if (cityFrom.province === cityTo.province) {
  //       allowBRTFastShipping = true;
  //     } else if (this.isAnyRegionExcluded(cityFrom.regione, cityTo.regione)) {
  //       allowBRTFastShipping = false;
  //     } else {
  //       allowBRTFastShipping = true;
  //     }
  //   } else {
  //     allowBRTFastShipping = false;
  //   }
  //   this.setState({
  //     allowBRTFastShipping,
  //     shippingType:
  //       !allowBRTFastShipping && this.state.shippingType === 'BRT_FAST'
  //         ? 'ESPRESSO'
  //         : this.state.shippingType,
  //     shippingCost:
  //       !allowBRTFastShipping && this.state.shippingType === 'BRT_FAST'
  //         ? this.props.checkout.shippingCost
  //         : this.state.shippingCost,
  //   });
  // };

  isAnyRegionExcluded = (from, to) => {
    const excludedRegions = ['SAR', 'SIC', 'CAL', 'BAS', 'PUG'];
    return !!excludedRegions.find(r => r === from || r === to);
  };

  getPudo = () => {
    const valid = this.validatePudo();
    if (valid) {
      this.props.loadPudos({
        address: this.state.pudoAddress,
        city: this.state.pudoCity,
        zipCode: this.state.pudoZipcode,
      });
    }
  };

  validatePudo = () => {
    if (
      !!this.state.pudoAddress &&
      this.state.pudoAddress !== '' &&
      !!this.state.pudoZipcode &&
      this.state.pudoZipcode !== '' &&
      !!this.state.pudoCity &&
      this.state.pudoCity !== ''
    ) {
      return true;
    } else {
      return false;
    }
  };

  componentWillReceiveProps(nextProps) {
    // GOOGLE ANALYTICS STEP 3
    if (nextProps.advancedGa && nextProps.cart !== this.props.cart) {
      this.gaStep3(nextProps.cart);
    }
  }

  getDistanceBetween = (lat1, lon1, lat2, lon2) => {
    const toRad = value => {
      /** Converts numeric degrees to radians */
      return (value * Math.PI) / 180;
    };
    //Radius of the earth in:  1.609344 miles,  6371 km  | var R = (6371 / 1.609344);
    var R = 3958.7558657440545; // Radius of earth in Miles
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  };

  changeCap = (event, newValue) => {
    // CALCOLA SPESE SPEDIZIONE NUOVO CAP

    // this.checkBRTFastShipping(null, newValue);

    this.props.getShippingCost(
      localStorage.getItem('cartId'),
      newValue || this.props.user.data.shipping.zipcode,
      this.props.country
    );

    if (this.props.checkout.guestCheckout) {
      this.setState({
        pudoZipcode: newValue,
      });
    }
  };

  changeShippingType = (type, cost) => {
    this.setState({
      shippingType: type,
      shippingCost: cost,
      pickupAtPharmacy: type === 'pickupAtPharmacy',
    });

    if (type === 'pudo') {
      this.props.change('shipping.useDefault', 'pudo');
    } else if (this.props.shippingDefault === 'pudo' && type !== 'pudo') {
      this.props.change('shipping.useDefault', 'true');
    }
  };

  saveShippingData = async shippingData => {
    const billing = { ...shippingData.billing };
    const shipping = { ...shippingData.shipping };
    const { guestCheckout } = this.props.checkout;

    if (billing.city && billing.city.value) {
      const billingCityArray = billing.city.value.split('|');
      billing.city = billingCityArray[0];
      billing.province = billingCityArray[1];
    }

    if (shipping.city && shipping.city.value) {
      const shippingCityArray = shipping.city.value.split('|');
      shipping.city = shippingCityArray[0];
      shipping.province = shippingCityArray[1];
    }

    if (shippingData.billing) {
      // Sistemiamo isCompany a boolean e, se non c'è la P.IVA
      // la settiamo a stringa vuota
      if (shippingData.billing.isCompany === 'false') {
        billing.isCompany = false;
        billing.vatNumber = '';
      } else {
        billing.isCompany = true;
      }
    }

    let shippingDataToSave = {
      ...shippingData,
      billing,
      shipping,
      shippingType: this.state.shippingType,
      slotHour: this.state.slotHour ? this.state.slotHour.label : null,
      pickupAtPharmacy: this.state.shippingType === 'pickupAtPharmacy',
      shippingCost: this.state.shippingCost,
    };

    if (guestCheckout) {
      shippingDataToSave = {
        ...shippingDataToSave,
        billing: !this.props.isInvoiceRequested
          ? {
              ...shippingDataToSave.billing,
              ...shippingDataToSave.shipping,
            }
          : shippingDataToSave.billing,
      };
    }

    if (!!shippingDataToSave.pickupAtPharmacy) {
      if (!!this.state.pickupLocation) {
        shippingDataToSave.pickupLocation = this.state.pickupLocation;
        delete shippingDataToSave.pickupLocation.pickup;
      } else {
        const { datiFarmacia } = this.props;
        shippingDataToSave.pickupLocation = {
          name: datiFarmacia.companyName,
          address1: datiFarmacia.address1,
          address2: datiFarmacia.address2,
          zipcode: datiFarmacia.zipcode,
          city: datiFarmacia.city,
          province: datiFarmacia.province,
          phone: datiFarmacia.phone,
        };
      }
    }

    if (this.props.shippingDefault !== 'pudo') {
      shippingDataToSave.shipping.pudoId = null;
    }

    if (this.props.shippingDefault === 'pudo' && !!this.state.selectedPudo) {
      const pudo = this.props.pudos.find(
        pd => pd.pudoId === this.state.selectedPudo
      );
      shippingDataToSave.pickupLocation = {
        name: pudo.pointName,
        address1: pudo.street + ' ' + pudo.streetNumber,
        address2: '',
        zipcode: pudo.zipCode,
        city: pudo.town,
        province: pudo.state,
        phone: '',
      };
      shippingDataToSave.shipping.pudoId = this.state.selectedPudo;

      if (guestCheckout) {
        shippingDataToSave.shipping.useDefault = 'true';
        shippingDataToSave.billing.useDefault = 'true';
      } else {
        shippingDataToSave.shipping.useDefault = 'false';
      }
    }

    // controllo disponibilità reale carrello e se differisce rimando a pagina carrello
    const stockAreAvailable = await this.checkStockRealTime();

    if (!stockAreAvailable) {
      this.props.loadCart();
      this.props.router.push('/carrello');
    } else {
      const { cartTotalWithExpenses, checkout } = this.props;

      const total =
        cartTotalWithExpenses -
        checkout.shippingCost +
        (this.state.shippingCost || 0);

      // GTM ADD SHIPPING INFO
      if (this.props.hasGoogleTagManager) {
        gtmToGa4AddShippingInfo(this.props.cart, total, {
          type: shippingDataToSave.shippingType,
          cost: shippingDataToSave.shippingCost,
          withPudo: !!shippingDataToSave.shipping.pudo,
        });
      }

      // GA4 ADD SHIPPING INFO
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4AddShippingInfo(this.props.cart, total, {
          type: shippingDataToSave.shippingType,
          cost: shippingDataToSave.shippingCost,
          withPudo: !!shippingDataToSave.shipping.pudo,
        });
      }

      // FKMX ADD SHIPPING INFO
      if (this.props.hasFarmakomMetrics) {
        fkmxAddShippingInfo(this.props.cart, total, {
          type: shippingDataToSave.shippingType,
          cost: shippingDataToSave.shippingCost,
          withPudo: !!shippingDataToSave.shipping.pudo,
        });
      }

      if (!!this.state.isGreenPackage) {
        shippingDataToSave.shippingCost += checkout.packagingGreenCost;
      }

      if (
        !!this.state.pickupAtPharmacy &&
        this.state.pickupPayed === 'pharmacy'
      ) {
        this.props.createOrder({
          cartId: localStorage.getItem('cartId'),
          ...this.props.checkout,
          ...shippingDataToSave,
          paymentType: 'ritiro in farmacia',
        });
      } else {
        // TODO - passare se viene ritirato in farmacia
        this.props.saveShipping(shippingDataToSave);
        this.props.router.push('/pagamento');
      }
    }
  };

  // CHECK GIACENZE REALI
  checkStockRealTime = async () => {
    try {
      const cartId = localStorage.getItem('cartId');
      const { endpoint, method, headers } = api.checkStockCart(cartId);
      const result = await axios({
        url: endpoint,
        method,
        headers: {
          ...headers,
          storeId: this.props.storeId,
        },
      });
      return result && result.data;
    } catch (err) {
      console.error('Error checking cart stock', err);
      return false;
    }
  };

  ///////////////////////////////////////////////////////////////
  // GESTIONE COMUNI AUTOCOMPLETE

  getCities = (input, callback) => {
    if (!input) {
      if (!!callback) {
        callback(null, {
          options: [],
        });
      }
    }

    this.props.loadCities(input || null, 4).then(action => {
      if (!!callback) {
        callback(null, {
          options:
            !!action.payload && !!action.payload.length
              ? action.payload.map(city => {
                  return {
                    value: `${city.city}|${city.province}`,
                    label: `${city.city} (${city.province})`,
                  };
                })
              : [],
        });
      }
    });
  };

  renderSelectCities = ({
    input,
    id,
    name,
    label,
    type,
    placeholder,
    meta: { touched, error },
  }) => {
    return (
      <div className={`form-group ${touched && error && 'error'}`}>
        <AsyncSelect
          name={name}
          value={input.value}
          openOnClick={false}
          loadOptions={this.getCities}
          labelKey="label"
          valueKey="value"
          onChange={val => {
            if (val && val.value) {
              if (this.props.checkout.guestCheckout) {
                this.setState({
                  pudoCity: val.value.split('|')[0],
                });
              }
              input.onChange(val);
            } else {
              input.onChange('');
            }
          }}
          onBlur={() => input.onBlur(input.value)}
          placeholder="Città"
          loadingPlaceholder="Caricamento..."
          clearValueText="Annulla"
          searchPromptText="Digita la città..."
        />
        {touched && error && <div className="error-text">{error}</div>}
      </div>
    );
  };

  renderSelectCitiesPudo = ({
    input,
    id,
    name,
    label,
    type,
    placeholder,
    meta: { touched, error },
  }) => {
    return (
      <div className={`form-group ${touched && error && 'error'}`}>
        <AsyncSelect
          name={name}
          value={input.value}
          openOnClick={false}
          loadOptions={this.getCities}
          labelKey="label"
          valueKey="value"
          onChange={val => {
            if (val && val.value) {
              input.onChange(val);
            } else {
              input.onChange('');
            }
          }}
          onBlur={() => input.onBlur(input.value)}
          placeholder="Città"
          loadingPlaceholder="Caricamento..."
          clearValueText="Annulla"
          searchPromptText="Digita la città..."
        />
        {touched && error && <div className="error-text">{error}</div>}
      </div>
    );
  };

  greenPackage = () =>
    this.setState(prev => ({ isGreenPackage: !prev.isGreenPackage }));

  renderTotalButtons = isMobile => {
    const {
      primaryColor,
      cartTotalWithExpenses,
      checkout,
      uiVariantButton,
    } = this.props;

    const bothPayments =
      this.state.shippingType === 'pickupAtPharmacy' &&
      this.props.pickupIsPayedByCash &&
      (this.state.shippingType !== 'pickupAtPharmacy' ||
        this.props.pickupIsPayedOnline);

    return (
      <div
        className={`total-buttons ${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          backgroundColor: isMobile ? primaryColor : 'transparent',
        }}
      >
        <div className="total">
          <span className="text">
            Totale <span className="hidden-xs"> con spese di spedizione</span>:
          </span>
          <span className="amount">
            <Price
              amount={
                cartTotalWithExpenses -
                checkout.shippingCost +
                (this.state.shippingCost || 0) +
                (this.state.isGreenPackage ? checkout.packagingGreenCost : 0)
              }
            />
          </span>
        </div>

        <div className="buttons">
          <Link
            to={this.state.withRicetta ? '/ricetta' : '/carrello'}
            className={`btn btn-back ${
              isMobile ? 'btn-inverse' : 'btn-outline btn-thick'
            }`}
            style={{
              maxHeight: 48,
              padding: isMobile ? '5px 25px' : '12px 18px',
              marginBottom: isMobile ? 24 : 0,
              color: isMobile
                ? '#fff'
                : uiVariantButton === '3'
                ? '#4f4f4f'
                : primaryColor,
            }}
          >
            Indietro
          </Link>
          <div
            className="buttons-proceed-container"
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: isMobile ? (bothPayments ? 3 : 1) : 'unset',
              backgroundColor: bothPayments ? 'transparent' : 'white',
              borderRadius: isMobile
                ? uiVariantButton === '1'
                  ? 12
                  : uiVariantButton === '3'
                  ? 6
                  : 0
                : 'unset',
            }}
          >
            {this.state.shippingType === 'pickupAtPharmacy' &&
              this.props.pickupIsPayedByCash && (
                <Button
                  type="submit"
                  onClick={() => this.setState({ pickupPayed: 'pharmacy' })}
                  className={`btn ${
                    isMobile
                      ? `btn-inverse no-padding ${
                          bothPayments ? 'both-payments' : ''
                        }`
                      : 'btn-primary btn-thick'
                  }`}
                  style={{
                    color: isMobile ? primaryColor : '#fff',
                    backgroundColor: isMobile ? '#fff' : primaryColor,
                    marginBottom: 8,
                  }}
                  disabled={
                    this.props.creating ||
                    !this.state.shippingType ||
                    (this.state.shippingType === 'SLOT' &&
                      !this.state.slotHour) ||
                    (this.props.shippingDefault === 'pudo' &&
                      !this.state.selectedPudo)
                  }
                >
                  {this.props.creating ? (
                    <div className="loading-slider">
                      <FaSpinner className="pulse" />
                    </div>
                  ) : isMobile ? (
                    'Paga in farmacia'
                  ) : (
                    'Conferma e paga in farmacia'
                  )}
                </Button>
              )}
            {(this.state.shippingType !== 'pickupAtPharmacy' ||
              this.props.pickupIsPayedOnline) && (
              <Button
                type="submit"
                className={`btn ${
                  isMobile
                    ? `btn-inverse no-padding ${
                        bothPayments ? 'both-payments' : ''
                      }`
                    : 'btn-primary btn-thick'
                }`}
                style={{
                  color: isMobile ? primaryColor : '#fff',
                  backgroundColor: isMobile ? '#fff' : primaryColor,
                }}
                disabled={
                  this.props.creating ||
                  !this.state.shippingType ||
                  (this.state.shippingType === 'SLOT' &&
                    !this.state.slotHour) ||
                  (this.props.shippingDefault === 'pudo' &&
                    !this.state.selectedPudo)
                }
              >
                {this.state.shippingType === 'pickupAtPharmacy'
                  ? isMobile
                    ? 'Paga online'
                    : 'Conferma e paga online'
                  : 'Metodo di pagamento'}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderPickupLocations = () => {
    const { pickupLocations } = this.props;
    const pickupLocationStyle = css`
      width: 100%;
      padding: 12px 16px;
      background-color: white;
      border-radius: 8px;
      margin-top: 4px;
      margin-bottom: 4px;
      font-size: 13px;
      cursor: pointer;
      &:hover {
        color: white;
        background-color: ${this.props.primaryColor};
      }
    `;
    return (
      <tr className="location-container">
        {pickupLocations
          .filter(item => item.pickup === 1) // considero solo le sedi che sono abilitate a punto di ritiro
          .map(location => {
            const selected =
              this.state.pickupLocation &&
              this.state.pickupLocation.id === location.id;
            return (
              <div
                onClick={() =>
                  this.setState({ pickupLocation: { ...location } })
                }
                css={pickupLocationStyle}
                style={{
                  backgroundColor: selected ? this.props.primaryColor : '',
                  color: selected ? 'white' : '',
                }}
              >
                {`${location.name}, ${location.zipcode} ${location.address1}, ${location.city} (${location.province})`}
              </div>
            );
          })}
      </tr>
    );
  };

  renderFastShippingDescription = () => {
    const now = new Date().setUTCHours(
      new Date().getUTCHours() - new Date().getTimezoneOffset() / 60
    );
    const hour = new Date(now).getUTCHours();
    const day = new Date(now).getDay();
    if (day === 5) {
      if (hour < 18) {
        return 'Ricevilo entro Lunedì';
      } else {
        return 'Ricevilo entro Martedì';
      }
    } else if (day === 6 || day === 0) {
      if (hour < 18) {
        return 'Ricevilo entro Martedì';
      } else {
        return 'Ricevilo entro Mercoledì';
      }
    } else {
      if (hour < 18) {
        return 'Ricevilo entro domani';
      } else {
        return 'Ricevilo entro dopodomani';
      }
    }
  };

  render() {
    const {
      checkout,
      cartTotalWithExpenses,
      cartTotal,
      freeShippingThreshold,
      hasSalesAbroad,
      invoicePolicy,
      allowPickupAtPharmacy,
      pickupIsPayedOnline,
      pickupAtPharmacyMessage,
      customPickupText,
      datiFarmacia,
      primaryColor,
      funzionalita,
      country,
      countries,
      pickupLocations,
      hasPudoBartolini,
      hasBrtFastShipping,
      pickupIsPayedByCash,
      pickupAtPharmacyFreeShippingThreshold,
      allowPremiumShipping,
      allowGreenPackaging,
    } = this.props;

    const user = this.props.user.data;
    const shippingTableStyle = css`
      tr {
        /* border-top-color: ${primary_s10_l90(primaryColor)}!important; */
      }
      .date-box:hover {
        background-color: ${primaryColor} !important;
      }
      .pudoItem:hover {
        background-color: ${primaryColor} !important;
      }
    `;

    let hasCustomPickupText = false;
    if (
      !!customPickupText &&
      Object.values(customPickupText).filter(t => !!t).length > 0
    ) {
      hasCustomPickupText = true;
    }

    return (
      <div className="spedizione" css={shippingTableStyle}>
        <form
          onSubmit={this.props.handleSubmit(
            this.saveShippingData,
            this.props.checkout.guestCheckout
          )}
        >
          <div className="row">
            <div className="col-md-6">
              <h4 className="checkout-title">Indirizzo di spedizione</h4>

              {!this.props.checkout.guestCheckout && (
                <>
                  <RadioContainer className="radio-container">
                    <Field
                      name="shipping.useDefault"
                      id="defaultShippingAddress"
                      component="input"
                      type="radio"
                      value="true"
                    />
                    <label htmlFor="defaultShippingAddress">
                      Utilizza il mio predefinito
                    </label>
                  </RadioContainer>

                  <hr />

                  {!this.props.checkout.guestCheckout &&
                    this.props.shippingDefault === 'true' && (
                      <address
                        className="shipping-address collapsing-element"
                        style={{ borderColor: primaryColor }}
                      >
                        {user.shipping.name}
                        <br />
                        {user.shipping.address1}
                        <br />
                        {user.shipping.address2 && (
                          <span>
                            {user.shipping.address2}
                            <br />
                          </span>
                        )}
                        {user.shipping.zipcode} {user.shipping.city} (
                        {user.shipping.province})
                      </address>
                    )}

                  {!this.props.checkout.guestCheckout && (
                    <RadioContainer className="radio-container">
                      <Field
                        name="shipping.useDefault"
                        id="newShippingAddress"
                        component="input"
                        type="radio"
                        value="false"
                      />
                      <label htmlFor="newShippingAddress">
                        Inserisci un nuovo indirizzo di spedizione
                      </label>
                    </RadioContainer>
                  )}
                </>
              )}

              {(this.props.shippingDefault === 'false' ||
                this.props.checkout.guestCheckout) && (
                <div className="new-shipping-address collapsing-element">
                  <div className="form-section">
                    {/* //inserisco email obbligatoria solo se guest-checkout */}
                    {!!checkout && checkout.guestCheckout && (
                      <Field
                        name="user.email"
                        component={TextField}
                        type="text"
                        label="Email"
                        onChange={ev =>
                          this.setState({ userEmail: ev.target.value })
                        }
                      />
                    )}
                    <Field
                      name="shipping.name"
                      component={TextField}
                      type="text"
                      label="Destinatario"
                      onChange={ev =>
                        this.setState({ shippingName: ev.target.value })
                      }
                    />
                    <Field
                      name="shipping.address1"
                      component={TextField}
                      type="text"
                      label="Indirizzo"
                      onChange={ev => {
                        if (checkout.guestCheckout) {
                          this.setState({ pudoAddress: ev.target.value });
                        }
                        this.setState({ shippingAddress1: ev.target.value });
                      }}
                    />
                    <Field
                      name="shipping.address2"
                      component={TextField}
                      type="text"
                      label="Note indirizzo"
                      onChange={ev =>
                        this.setState({ shippingAddress2: ev.target.value })
                      }
                    />
                    {hasSalesAbroad && (
                      <Field
                        name="shipping.country"
                        component={SelectField}
                        label="Nazione"
                        nullOption={{
                          value: 'Italia',
                          label: 'Italia',
                        }}
                        options={countries.map(c => ({
                          value: c.name,
                          label: c.name,
                        }))}
                      />
                    )}
                    <div className="row">
                      <div className="col-sm-6">
                        <Field
                          name="shipping.zipcode"
                          component={TextField}
                          id="shipping.zipcode"
                          placeholder={user.shipping.zipcode}
                          type="text"
                          label="CAP"
                          normalize={normalizeZipcode}
                          onChange={this.changeCap}
                        />
                      </div>
                      <div className="col-sm-6">
                        {hasSalesAbroad && country !== 'Italia' ? (
                          <Field
                            name="shipping.city"
                            id="shipping.city"
                            component={TextField}
                            label="Città"
                          />
                        ) : (
                          <Field
                            name="shipping.city"
                            id="shipping.city"
                            component={this.renderSelectCities}
                            label="Città"
                          />
                        )}
                      </div>
                    </div>

                    <Field
                      name="shipping.phone"
                      component={TextField}
                      type="text"
                      label="Telefono"
                    />
                    {!this.props.checkout.guestCheckout && (
                      <CheckboxContainer>
                        <Field
                          name="shipping.setAsDefault"
                          component="input"
                          type="checkbox"
                          id="shippingSetDefault"
                        />
                        <label htmlFor="shippingSetDefault">
                          Salva come indirizzo predefinito
                        </label>
                      </CheckboxContainer>
                    )}
                  </div>
                </div>
              )}

              {invoicePolicy !== 'NONE' &&
                (user.billing.isCompany || invoicePolicy === 'ALL') && <hr />}

              {invoicePolicy !== 'NONE' &&
                (user.billing.isCompany || invoicePolicy === 'ALL') && (
                  <CheckboxContainer className="invoiceRequest">
                    <Field
                      name="isInvoiceRequested"
                      component="input"
                      type="checkbox"
                      id="isInvoiceRequested"
                    />
                    <label htmlFor="isInvoiceRequested">Richiedi fattura</label>
                  </CheckboxContainer>
                )}

              <hr />

              {this.props.isInvoiceRequested && (
                <div className="collapsing-element">
                  <h4 className="checkout-title">Indirizzo di fatturazione</h4>

                  {!this.props.checkout.guestCheckout && (
                    <RadioContainer className="radio-container">
                      <Field
                        name="billing.useDefault"
                        id="defaultBillingAddress"
                        component="input"
                        type="radio"
                        value="true"
                      />
                      <label htmlFor="defaultBillingAddress">
                        Utilizza il mio indirizzo predefinito
                      </label>
                    </RadioContainer>
                  )}
                  {this.props.billingDefault === 'true' &&
                    !this.props.checkout.guestCheckout &&
                    this.props.shippingDefault === 'true' && (
                      <address
                        className="billing-address collapsing-element"
                        style={{ borderColor: primaryColor }}
                      >
                        {!!this.props.isCompany && (
                          <p style={{ marginBottom: 0 }}>
                            {user.billing.company}
                          </p>
                        )}
                        {user.billing.firstname} {user.billing.lastname}
                        <br />
                        {user.billing.address1}
                        <br />
                        {user.billing.address2 && (
                          <span>
                            {user.billing.address2}
                            <br />
                          </span>
                        )}
                        {user.billing.zipCode} {user.billing.city} (
                        {user.billing.province})<br />
                        C.F. {user.billing.taxCode}
                        {user.billing.vatNumber && (
                          <span>
                            {' '}
                            - P.IVA {user.billing.vatNumber}
                            <br />
                          </span>
                        )}
                      </address>
                    )}

                  <hr />

                  {!this.props.checkout.guestCheckout && (
                    <RadioContainer className="radio-container">
                      <Field
                        name="billing.useDefault"
                        id="newBillingAddress"
                        component="input"
                        type="radio"
                        value="false"
                      />
                      <label htmlFor="newBillingAddress">
                        Inserisci un nuovo indirizzo di fatturazione
                      </label>
                    </RadioContainer>
                  )}

                  {((!this.props.checkout.guestCheckout &&
                    this.props.billingDefault === 'false') ||
                    this.props.checkout.guestCheckout) && (
                    <div className="new-billing-address collapsing-element">
                      <div className="form-section">
                        <div className="invoice-address-radios">
                          <div className="row">
                            <div className="col-sm-6">
                              <RadioContainer className="radio-container">
                                <Field
                                  name="billing.isCompany"
                                  component="input"
                                  type="radio"
                                  id="isPrivate"
                                  value="false"
                                />
                                <label htmlFor="isPrivate">Privato</label>
                              </RadioContainer>
                            </div>
                            <div className="col-sm-6">
                              <RadioContainer className="radio-container">
                                <Field
                                  name="billing.isCompany"
                                  component="input"
                                  type="radio"
                                  id="isCompany"
                                  value="true"
                                />
                                <label htmlFor="isCompany">Azienda</label>
                              </RadioContainer>
                            </div>
                          </div>
                        </div>

                        {this.props.isCompany === 'true' && (
                          <div>
                            <Field
                              name="billing.company"
                              component={TextField}
                              type="text"
                              label="Ragione sociale"
                            />
                            <Field
                              name="billing.sdiCode"
                              component={TextField}
                              type="text"
                              label="Codice univoco SDI"
                            />
                            <Field
                              name="billing.pec"
                              component={TextField}
                              type="text"
                              label="Indirizzo PEC"
                            />
                          </div>
                        )}
                        <Field
                          name="billing.firstname"
                          component={TextField}
                          type="text"
                          label="Nome"
                        />
                        <Field
                          name="billing.lastname"
                          component={TextField}
                          type="text"
                          label="Cognome"
                        />
                        <Field
                          name="billing.taxCode"
                          component={TextField}
                          type="text"
                          label="Codice fiscale"
                          normalize={normalizeTaxCode}
                        />
                        {this.props.isCompany === 'true' ? (
                          <Field
                            name="billing.vatNumber"
                            component={TextField}
                            type="text"
                            label="P.IVA"
                          />
                        ) : null}
                        <Field
                          name="billing.address1"
                          component={TextField}
                          type="text"
                          label="Indirizzo"
                        />
                        <Field
                          name="billing.address2"
                          component={TextField}
                          type="text"
                          label="Note indirizzo"
                        />
                        <div className="row">
                          <div className="col-sm-6">
                            <Field
                              name="billing.zipcode"
                              component={TextField}
                              id="billing.zipcode"
                              placeholder={user.billing.zipcode}
                              type="text"
                              label="CAP"
                              normalize={normalizeZipcode}
                            />
                          </div>
                          <div className="col-sm-6">
                            <Field
                              name="billing.city"
                              id="billing.city"
                              component={this.renderSelectCities}
                              label="Città"
                            />
                          </div>
                        </div>
                        <Field
                          name="billing.phone"
                          component={TextField}
                          type="text"
                          label="Telefono"
                        />
                        {!this.props.checkout.guestCheckout && (
                          <CheckboxContainer>
                            <Field
                              name="billing.setAsDefault"
                              component="input"
                              type="checkbox"
                              id="billingSetDefault"
                            />
                            <label htmlFor="billingSetDefault">
                              Salva come indirizzo predefinito
                            </label>
                          </CheckboxContainer>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="col-md-6">
              <div className="mobile-spacer" />
              <h4 className="checkout-title">Modalità di spedizione</h4>
              <div
                className="table shipping-table"
                css={shippingTableStyle}
                style={{ display: 'flex' }}
              >
                <tbody style={{ display: 'flex', flexDirection: 'column' }}>
                  {this.props.existsFreeShipping &&
                    !this.props.hasFreeShipping && (
                      <tr
                        style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <td style={{ flex: 2 }}>
                          <div className="red shipping-title">Gratuita</div>
                          <div className="text red">
                            La spedizione è gratuita con un{' '}
                            <b>
                              ordine minimo di{' '}
                              <Price amount={freeShippingThreshold} />
                            </b>
                          </div>
                        </td>
                        <td style={{ flex: 2 }} colSpan="2">
                          <Link
                            to="/"
                            className="btn btn-outline btn-thick btn-add"
                          >
                            Aggiungi prodotti
                          </Link>
                        </td>
                      </tr>
                    )}

                  {allowGreenPackaging && (
                    <div
                      style={{
                        marginTop: '2rem',
                        borderRadius: '12px',
                        backgroundColor: '#9ed69ea6',
                      }}
                    >
                      <h4
                        className="checkout-title"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                          backgroundColor: '#60935D',
                          color: 'white',
                          marginBottom: 0,
                        }}
                      >
                        <FaGlobeAmericas
                          size={24}
                          style={{ color: '#f5f5f5' }}
                        />
                        {/* <FaGlobeEurope size={20} style={{ color: '#f5f5f5' }} /> */}
                        {/* <FaRecycle size={20} style={{ color: 'green' }} /> */}
                        Packaging Sostenibile e protettivo
                      </h4>

                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 'bold',
                          padding: '16px 24px 0px',
                        }}
                      >
                        Assicurati che i tuoi prodotti arrivino sani e salvi
                      </div>

                      <div
                        className="table shipping-table"
                        css={shippingTableStyle}
                        style={{
                          display: 'flex',
                          flexFlow: 'column',
                          backgroundColor: 'transparent',
                          padding: 16,
                          paddingLeft: 24,
                          paddingRight: 0,
                        }}
                      >
                        <tr
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                          }}
                        >
                          <td style={{ flex: 6, padding: 0 }}>
                            <div className="text">
                              Ricevi i tuoi prodotti e restituisci
                              l'imballaggio. Scegliendo la nostra scatola
                              sostenibile non solo proteggi il pianeta, ma anche
                              il tuoi prodotti
                            </div>
                          </td>
                          <td
                            className="price-col text-center"
                            style={{ flex: 1, padding: 0 }}
                          >
                            <Price amount={checkout.packagingGreenCost} />
                          </td>
                          <td style={{ flex: 1, padding: 0 }}>
                            <CheckboxContainer className="isGreenPackage">
                              <Field
                                name="isGreenPackage"
                                component="input"
                                type="checkbox"
                                id="isGreenPackage"
                                checked={this.state.isGreenPackage}
                                onChange={this.greenPackage}
                              />
                              <label htmlFor="isGreenPackage"></label>
                            </CheckboxContainer>
                          </td>
                        </tr>
                      </div>
                    </div>
                  )}

                  <tr
                    style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      borderTop: allowGreenPackaging ? 'none' : null,
                    }}
                  >
                    <td style={{ flex: 6 }}>
                      {this.props.checkout.shippingCost === 0 ? (
                        <div className="color shipping-title">Gratuita</div>
                      ) : (
                        <div className="shipping-title">Rapida</div>
                      )}
                      <div className="text">
                        Spedizione rapida con Corriere Espresso, in{' '}
                        <b>2 giorni lavorativi</b>
                      </div>
                    </td>
                    <td style={{ flex: 1 }} className="price-col text-center">
                      <Price amount={checkout.shippingCost} />
                    </td>
                    <td style={{ flex: 1 }} className="radio-col text-center">
                      <RadioContainer className="radio-container">
                        <input
                          type="radio"
                          id="shipping"
                          name="shippingFee"
                          checked={this.state.shippingType === 'ESPRESSO'}
                          onClick={() => {
                            this.changeShippingType(
                              'ESPRESSO',
                              checkout.shippingCost
                            );
                          }}
                        />
                        <label htmlFor="shipping" />
                      </RadioContainer>
                    </td>
                  </tr>
                  {/* {!!hasBrtFastShipping &&
                    !!checkout.brtFastShippingCost &&
                    !!this.state.allowBRTFastShipping &&
                    country === 'Italia' && (
                      <tr
                        style={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <td style={{ flex: 6 }}>
                          <div className="shipping-title">
                            {this.renderFastShippingDescription()}
                          </div>
                        </td>
                        <td
                          style={{ flex: 1 }}
                          className="price-col text-center"
                        >
                          <Price amount={checkout.brtFastShippingCost} />
                        </td>
                        <td
                          style={{ flex: 1 }}
                          className="radio-col text-center"
                        >
                          <RadioContainer className="radio-container">
                            <input
                              disabled={
                                !this.state.allowBRTFastShipping ||
                                country !== 'Italia'
                              }
                              type="radio"
                              id="brtFastShipping"
                              name="brtFastShipping"
                              checked={this.state.shippingType === 'BRT_FAST'}
                              onClick={() => {
                                this.changeShippingType(
                                  'BRT_FAST',
                                  checkout.brtFastShippingCost
                                );
                              }}
                            />
                            <label htmlFor="brtFastShipping" />
                          </RadioContainer>
                        </td>
                      </tr>
                    )} */}
                  {!!allowPickupAtPharmacy &&
                    (pickupIsPayedOnline || pickupIsPayedByCash) &&
                    (!this.state.withRicetta ||
                      (this.state.withRicetta &&
                        this.props.checkout.ricetta.numeroRicetta)) && (
                      <>
                        <tr
                          style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <td style={{ flex: 6 }}>
                            {!!hasCustomPickupText ? (
                              <>
                                <div className="shipping-title">
                                  {customPickupText.customPickupLabel ||
                                    'Ritiro in sede'}
                                </div>
                                <div className="text">
                                  {customPickupText.customPickupDescription ||
                                    'Ritira il tuo ordine direttamente nella nostra sede'}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="shipping-title">
                                  Ritiro in sede
                                </div>
                                <div className="text">
                                  Ritira il tuo ordine direttamente nella nostra
                                  sede
                                </div>
                              </>
                            )}

                            {!!pickupAtPharmacyMessage && (
                              <div className="text">
                                {pickupAtPharmacyMessage}
                              </div>
                            )}
                            {cartTotal <
                              pickupAtPharmacyFreeShippingThreshold && (
                              <div
                                className="text"
                                style={{ color: '#f77878' }}
                              >
                                Il ritiro è gratuito con un{' '}
                                <b>
                                  ordine minimo di €{' '}
                                  {pickupAtPharmacyFreeShippingThreshold !==
                                    undefined &&
                                    pickupAtPharmacyFreeShippingThreshold.toFixed(
                                      2
                                    )}
                                </b>
                              </div>
                            )}
                            {pickupLocations.length === 1 && (
                              <address
                                className="pickup-address"
                                style={{ borderColor: primaryColor }}
                              >
                                {datiFarmacia.address1}
                                <br />
                                {datiFarmacia.city}
                              </address>
                            )}
                            {!pickupIsPayedOnline && (
                              <div className="text small">
                                Pagamento al ritiro
                              </div>
                            )}
                          </td>
                          <td
                            style={{ flex: 1 }}
                            className="price-col align-top-col text-center"
                          >
                            <Price
                              amount={
                                cartTotal <
                                pickupAtPharmacyFreeShippingThreshold
                                  ? checkout.pickupAtFarmacy
                                  : 0
                              }
                            />
                          </td>
                          <td
                            style={{ flex: 1 }}
                            className="radio-col align-top-col text-center"
                          >
                            <RadioContainer className="radio-container">
                              <input
                                // disabled={this.props.shippingDefault === 'pudo'}
                                type="radio"
                                id="pickupShippingFee"
                                name="pickupShippingFee"
                                checked={this.state.pickupAtPharmacy}
                                onClick={() => {
                                  // if (this.props.shippingDefault !== 'pudo') {
                                  this.changeShippingType(
                                    'pickupAtPharmacy',
                                    cartTotal <
                                      pickupAtPharmacyFreeShippingThreshold
                                      ? checkout.pickupAtFarmacy
                                      : 0
                                  );
                                  // }
                                }}
                              />
                              <label htmlFor="pickupShippingFee" />
                            </RadioContainer>
                          </td>
                        </tr>
                        {this.state.shippingType === 'pickupAtPharmacy' &&
                          pickupLocations.length > 1 && (
                            <tr style={{ borderTop: 0 }}>
                              {this.renderPickupLocations()}
                            </tr>
                          )}
                      </>
                    )}

                  {!!hasPudoBartolini && (
                    <tr
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <td style={{ flex: 6 }}>
                        <div className="shipping-title">Pudo</div>
                        <div className="text">
                          Scegli il tuo punto di ritiro più vicino a te
                        </div>
                      </td>
                      <td style={{ flex: 1 }} className="price-col text-center">
                        {/*<Price amount={checkout.brtFastShippingCost} />*/}
                        <Price
                          amount={
                            !!this.props.checkout &&
                            this.props.checkout.shippingCost !== 0
                              ? checkout.brtPudoShippingCost
                              : 0
                          }
                        />
                      </td>
                      <td
                        style={{ flex: 1 }}
                        className="radio-col text-center"
                        onClick={() =>
                          this.changeShippingType(
                            'PUDO',
                            !!this.props.checkout &&
                              this.props.checkout.shippingCost !== 0
                              ? checkout.brtPudoShippingCost
                              : 0
                          )
                        }
                      >
                        <RadioContainer className="radio-container">
                          <Field
                            name="shipping.useDefault"
                            id="pudo"
                            component="input"
                            type="radio"
                            value="pudo"
                          />

                          <label htmlFor="pudo" />
                        </RadioContainer>
                      </td>
                    </tr>
                  )}

                  {this.props.shippingDefault === 'pudo' &&
                    this.state.shippingType === 'PUDO' && (
                      <div
                        className="new-shipping-address collapsing-element"
                        style={{ margin: '0 8px' }}
                      >
                        <div style={{ fontSize: 13, marginTop: 16 }}>
                          {`Abbiamo trovato ${this.props.pudos.length} punti di ritiro vicini al tuo indirizzo di consegna predefinito`}
                          <b style={{ color: primaryColor }}>
                            {checkout.guestCheckout ? (
                              <>
                                {' ' +
                                  this.state.pudoAddress +
                                  ', ' +
                                  this.state.pudoZipcode +
                                  ', ' +
                                  this.state.pudoCity}
                              </>
                            ) : (
                              <>
                                {' ' +
                                  user.shipping.address1 +
                                  ', ' +
                                  user.shipping.zipcode +
                                  ', ' +
                                  user.shipping.city}
                              </>
                            )}
                          </b>
                          .
                        </div>
                        <div style={{ marginTop: 24, fontSize: 13 }}>
                          Oppure puoi cercare altri punti di ritiro vicino ad un
                          nuovo indirizzo:
                        </div>
                        <div
                          className="form-section"
                          style={{ marginTop: 16, marginBottom: 16 }}
                        >
                          <Field
                            name="pudo.address1"
                            component={TextField}
                            type="text"
                            label="Indirizzo"
                            onChange={ev =>
                              this.setState({ pudoAddress: ev.target.value })
                            }
                          />
                          <div className="row">
                            <div className="col-sm-6">
                              <Field
                                name="pudo.zipcode"
                                component={TextField}
                                id="pudo.zipcode"
                                // placeholder="CAP"
                                type="text"
                                label="CAP"
                                normalize={normalizeZipcode}
                                onChange={ev =>
                                  this.setState({
                                    pudoZipcode: ev.target.value,
                                  })
                                }
                              />
                            </div>
                            <div className="col-sm-6">
                              <Field
                                name="pudo.city"
                                id="pudo.city"
                                component={this.renderSelectCitiesPudo}
                                label="Città"
                                onChange={ev =>
                                  this.setState({
                                    pudoCity: ev.value.split('|')[0],
                                    pudoProvince: ev.value.split('|')[1],
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                  {this.props.shippingDefault === 'pudo' &&
                    this.state.shippingType === 'PUDO' &&
                    this.props.pudos.length > 0 && (
                      <div
                        className="new-shipping-address collapsing-element pudoList"
                        style={{ margin: '0 8px' }}
                      >
                        {this.props.pudos.map(pudo => {
                          const isSelected =
                            pudo.pudoId === this.state.selectedPudo;
                          return (
                            <div
                              style={
                                isSelected
                                  ? {
                                      backgroundColor: primaryColor,
                                      color: 'white',
                                    }
                                  : {}
                              }
                              onClick={() =>
                                this.setState({
                                  selectedPudo:
                                    this.state.selectedPudo === pudo.pudoId
                                      ? null
                                      : pudo.pudoId,
                                })
                              }
                              className="pudoItem"
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                              >
                                <div
                                  style={{ fontSize: 14, fontWeight: 'bold' }}
                                >
                                  {pudo.pointName}
                                </div>
                                <div style={{ fontSize: 13 }}>
                                  {pudo.fullAddress}
                                </div>
                              </div>
                              <div style={{ fontSize: 14, fontWeight: 'bold' }}>
                                {pudo.distanceFromPoint > 1000
                                  ? (pudo.distanceFromPoint / 1000).toFixed(1) +
                                    ' km'
                                  : pudo.distanceFromPoint + ' m'}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                  {!!allowPremiumShipping && (
                    <tr
                      style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <td style={{ flex: 6 }}>
                        <div className="shipping-title">
                          Spedizione premium
                          <div className="text"></div>
                        </div>
                      </td>
                      <td style={{ flex: 1 }} className="price-col text-center">
                        <Price amount={checkout.premiumShippingCost} />
                      </td>
                      <td style={{ flex: 1 }} className="radio-col text-center">
                        <RadioContainer className="radio-container">
                          <input
                            type="radio"
                            id="premiumShipping"
                            name="premiumShipping"
                            checked={this.state.shippingType === 'PREMIUM'}
                            onClick={() => {
                              this.changeShippingType(
                                'PREMIUM',
                                checkout.premiumShippingCost
                              );
                            }}
                          />
                          <label htmlFor="premiumShipping" />
                        </RadioContainer>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td colSpan="3">
                      <div className="text smaller">
                        Le spese di spedizione possono variare per alcune
                        località, come Sicilia ed isole minori
                      </div>
                    </td>
                  </tr>
                </tbody>
              </div>

              {!!checkout.shippingSurcharge && (
                <div className="shipping-surcharge">
                  <div className="icon" style={{ color: primaryColor }}>
                    <MdHelpOutline />
                  </div>
                  <div className="text">
                    Nota: l'indirizzo di spedizione appartiene ad una zona con
                    sovrapprezzo da parte del corriere.
                  </div>
                </div>
              )}
            </div>
          </div>

          <hr className="total-line" />

          {this.renderTotalButtons(this.props.isMobile)}
        </form>
      </div>
    );
  }
}

const validate = (values, guestCheckout) => {
  const errors = {
    shipping: {},
    user: {},
    billing: {},
  };

  // check se è guest checkout
  if (!!guestCheckout && values.user) {
    if (!values.user.email) {
      errors.user.email = 'Richiesto';
    }
  }

  if (values.shipping) {
    if (!values.shipping.name) {
      errors.shipping.name = 'Richiesto';
    }
    if (!values.shipping.address1) {
      errors.shipping.address1 = 'Richiesto';
    }
    if (!values.shipping.city) {
      errors.shipping.city = 'Richiesto';
    }
    if (!values.shipping.zipcode) {
      errors.shipping.zipcode = 'Richiesto';
    }
    if (!values.shipping.phone) {
      errors.shipping.phone = 'Richiesto';
    }
  }

  if (values.billing) {
    if (!values.billing.company) {
      errors.billing.company = 'Richiesto';
    }
    if (!values.billing.firstname) {
      errors.billing.firstname = 'Richiesto';
    }
    if (!values.billing.lastname) {
      errors.billing.lastname = 'Richiesto';
    }
    if (!values.billing.vatNumber) {
      errors.billing.vatNumber = 'Richiesto';
    }

    if (
      !nomeCoerente(values.billing.taxCode, values.billing.firstname) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.firstname = 'Nome non coerente con Codice Fiscale';
    }
    if (!values.billing.lastname) {
      errors.billing.lastname = 'Richiesto';
    }
    if (
      !cognomeCoerente(values.billing.taxCode, values.billing.lastname) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.lastname = 'Cognome non coerente con Codice Fiscale';
    }
    if (!values.billing.vatNumber) {
      errors.billing.vatNumber = 'Richiesto';
    }
    if (!values.billing.sdiCode && !values.billing.pec) {
      errors.billing.sdiCode = 'Richiesti codice SDI o PEC';
      errors.billing.pec = 'Richiesti codice SDI o PEC';
    }

    if (!values.billing.taxCode) {
      errors.billing.taxCode = 'Richiesto';
    } else if (
      !codiceFiscaleValido(values.billing.taxCode) &&
      values.billing.isCompany != 'true'
    ) {
      errors.billing.taxCode = 'Codice fiscale non valido';
    }

    if (!values.billing.address1) {
      errors.billing.address1 = 'Richiesto';
    }
    if (!values.billing.city) {
      errors.billing.city = 'Richiesto';
    }
    if (!values.billing.zipcode) {
      errors.billing.zipcode = 'Richiesto';
    }
    if (!values.billing.phone) {
      errors.billing.phone = 'Richiesto';
    }
  }
  return errors;
};

const normalizeTaxCode = value => (value || '').toUpperCase();
const normalizeZipcode = value => (value || '').replace(/[^\d]/g, '');

Spedizione = reduxForm({
  form: 'checkoutShipping',
  enableReinitialize: true,
  validate,
})(Spedizione);

const mapStateToProps = state => {
  const selector = formValueSelector('checkoutShipping');
  const { shipping, billing } = state.checkout;
  return {
    isMobile: state.layout.isMobile,
    storeId: state.store.data.storeId,
    countries: state.countries.data,
    user: state.user,
    cart: state.cart,
    checkout: state.checkout,
    freeShippingThreshold:
      state.checkout.shippingAbroadThreshold ||
      state.store.data.costiSpedizione.freeShippingThreshold,
    hasBrtFastShipping: state.store.data.features.hasBrtFastShipping,
    hasSalesAbroad: state.store.data.features.hasSalesAbroad,
    invoicePolicy: state.store.data.funzionalita.invoicePolicy,
    allowPickupAtPharmacy: state.store.data.funzionalita.allowPickupAtPharmacy,
    pickupIsPayedOnline: state.store.data.funzionalita.pickupIsPayedOnline,
    pickupIsPayedByCash: state.store.data.funzionalita.pickupIsPayedByCash,
    allowPremiumShipping: state.store.data.costiSpedizione.allowPremiumShipping,
    allowGreenPackaging: state.store.data.costiSpedizione.allowPackagingGreen,
    pickupAtPharmacyMessage:
      state.store.data.funzionalita.pickupAtPharmacyMessage,
    customPickupText: state.store.data.funzionalita.customPickupText,
    datiFarmacia: state.store.data.datiFarmacia,
    funzionalita: state.store.data.funzionalita,
    shippingDefault: selector(state, 'shipping.useDefault'),
    billingDefault: selector(state, 'billing.useDefault'),
    isCompany: selector(state, 'billing.isCompany'),
    isInvoiceRequested: selector(state, 'isInvoiceRequested'),
    isGreenPackage: selector(state, 'isGreenPackage'),
    country: selector(state, 'shipping.country'),
    city: selector(state, 'shipping.city'),
    cartTotalWithExpenses: getCartTotalWithExpenses(state),
    cartTotal: getCartTotalDiscountedCoupon(state),
    existsFreeShipping: existsFreeShipping(state),
    hasFreeShipping: hasFreeShipping(state),
    initialValues: {
      shipping: {
        ...shipping,
        country: shipping.country || 'Italia',
      },
      billing,
      user: { email: '' },
      // pudo: {
      //   address: state.user.data.shipping.address1,
      //   city: state.user.data.shipping.city,
      //   zipCode: state.user.data.shipping.zipcode
      // }
    },
    advancedGa: state.store.data.features.advancedGa,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    pickupLocations: state.store.data.pickupLocations,
    pudos: state.pudo.data,
    hasPudoBartolini: state.store.data.features.hasPudoBartolini,
    uiVariantButton: state.store.data.uiVariants.buttons,
    creating: state.checkout.loading,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    pickupAtPharmacyFreeShippingThreshold:
      state.store.data.costiSpedizione.pickupAtPharmacyFreeShippingThreshold,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getShippingCost,
    saveShipping,
    createOrder,
    loadCities,
    getEnabledCities,
    geocodeAddress,
    loadCountries,
    loadPudos,
    loadCart,
    setGuestCheckout,
  })(Spedizione)
);
